import { Badge, Card } from '@classgo/ui';

import { useT } from '../../i18n';
import { useTenant } from '../../tenant/tenant-provider';
import { SetupChecklist } from '../setup/checklist';
import { FamilyCard } from './family-card';

/**
 * The landing screen after login: who you are and what you are looking at. Modules replace it
 * as they arrive (#18, #19).
 */
export const HomeScreen = () => {
  const t = useT();
  const { session, sede } = useTenant();
  const name = session.user.givenName ?? session.user.email;
  return (
    <div className="mx-auto max-w-3xl space-y-4">
      <Card>
        <div className="flex items-start justify-between gap-4">
          <div>
            <h2 className="text-2xl font-semibold text-gray-900">{t('home.welcome', { name })}</h2>
            <p className="mt-1 text-sm text-gray-500">
              {t('home.context', { tenant: session.tenant.name, sede: sede.name })}
            </p>
          </div>
          {session.tenant.isDemo ? <Badge tone="info">Demo</Badge> : null}
        </div>
        <p className="mt-6 text-sm text-gray-600">{t('home.next')}</p>
      </Card>
      {session.roles.includes('GUARDIAN') ? <FamilyCard /> : null}
      {session.permissions.all || session.permissions.keys.includes('tenant:read') ? (
        <SetupChecklist compact />
      ) : null}
    </div>
  );
};
